import {getDailyView} from '../api/getDailyView';
import {setGetDailyViewAction} from '../action';

const setGetDailyView = (params ) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getDailyView(params);
      
            if (data.status === 'success') {

                dispatch(setGetDailyViewAction(data.data));           
            }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetDailyView
}